<template>
  <v-content>
    <v-container 
      fluid 
      fill-height>
      <v-layout 
        row 
        wrap 
        fill-height>
        <!--<v-expand-transition type="animation">-->
        <TabCreazioneNota v-if="bottomNav === 'new-nota'"/>
        <TabDettaglioNote v-if="bottomNav === 'lista-note'"/>
        <TabReport v-if="bottomNav === 'report'"/>
        <!--</v-expand-transition>-->
      </v-layout>
    </v-container>
    <v-bottom-nav 
      :active.sync="bottomNav" 
      :value="true" 
      class="primary" 
      fixed 
      app>
      <v-btn 
        value="new-nota" 
        class="tree--text">
        <span>Creazione nota</span>
        <v-icon>list_alt</v-icon>
      </v-btn>

      <v-btn 
        value="lista-note" 
        class="tree--text">
        <span>Le mie note</span>
        <v-icon>ballot</v-icon>
      </v-btn>

      <v-btn 
        value="report" 
        class="tree--text">
        <span>Report</span>
        <v-icon>pie_chart</v-icon>
      </v-btn>
    </v-bottom-nav>
    <loading 
      :show="isLoading" 
      :label="textLoading"/>
  </v-content>
</template>

<script>
import { NotaSpese } from "../stores";
import { TabDettaglioNote, TabCreazioneNota, TabReport, Loading } from "../components";

export default {
  name: "PIndex",
  components: {
    Loading,
    TabDettaglioNote,
    TabCreazioneNota,
    TabReport
  },
  data() {
    return {
      bottomNav: "new-nota"
    };
  },
  computed: {
    isLoading() {
      return this.$store.getters["notaSpese/loading"];
    },
    textLoading() {
      return this.$store.getters["notaSpese/textProcess"];
    }
  },
  watch: {},
  beforeCreate() {
    if (!this.$store.hasModule("notaSpese")) {
      this.$store.registerModule("notaSpese", NotaSpese);
    }
  },
  created() {},
  mounted() {},
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// modules/Home/views/src/pages/Index.vue